import React, { Component } from "react";

export class Icons extends Component {
  render() {
    return (
      <div className="theicons">
        <div className="wrapper">
          <a href="https://github.com/blvck-code" className="fa fa-github"></a>
          <a href="https://www.linkedin.com/in/maurice-brian-oluoch-ba1269121/" className="fa fa-linkedin"></a>
          <a href="tel:+254795772333" className="fa fa-phone"></a>
          <a href="https://www.instagram.com/oluoch_jnr/" className="fa fa-instagram"></a>
          <a href="https://twitter.com/blvck_code" className="fa fa-twitter"></a>
        </div>
      </div>
    );
  }
}

export default Icons;
